var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#60646c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.3335 16.666s.55555.8333 1.6667.8333c1.1111 0 1.6666-.8333 1.6666-.8333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.0002 7.5c0 1.66667 1.6666 2.5 1.6666 4.1667 0 2.5-3.7037 3.3333-6.6666 3.3333-2.96299 0-6.6667-.8333-6.6667-3.3333 0-1.6667 1.66666-2.29888 1.66666-4.1667 0-2.5 1.66668-5 5.00004-5 3.3333 0 5 2.5 5 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationGrey);
export default __webpack_public_path__ + "static/media/notification_grey.e5d1b161a7978e69c7e95a0289bf9641.svg";
export { ForwardRef as ReactComponent };